<template>
  <div class="card card_generic"
  :class="{ sm: size == 'sm' }"
  >
    <h4 class="card_title"
    v-if="title"
    v-html="title"
    :class="title_class"
    ></h4>

    <p class="card_subtitle"
    v-if="subtitle"
    >
      {{subtitle}}
    </p>

    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'card_generic',
  props: [
    'title',
    'subtitle',
    'title_class',
    'size'
  ],
  data () {
    return {
      
    }
  },
  components: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';

.card_generic {

  width: 100%;
  background: #FFF;
  border-radius: 5px;
  box-shadow: 1px 1px 3px #CCC;
  padding: 0.8em;
  margin: 1em 0;
  
  .card_title {
    margin-bottom: 0.5em;
    font-size: 1.2rem;
  }

  .card_title.orange {
    background-color: $dcom-orange;
    color: #FFF;
    padding: 1em;

    a {
      color: #FFF;
    }
  }

  .card_title.teal {
    background-color: $dcom-teal;
    color: #FFF;
    padding: 1em;

    a {
      color: #FFF;
    }
  }

  .card_subtitle {
    color: #aaa;
  }
}

.card_generic.sm {

  margin: 0em 0;
  padding: 0.4em 0.6em;

  .card_title {
    margin-bottom: 0.8em;
    font-size: 1.0rem;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/cards/card_generic.vue